import { call, put, select, takeEvery } from "redux-saga/effects";
import {
  dataGuardFiltersEndPoints,
  GET_DATA_GUARD_FILTERS_LIST,
  getDetailsURL,
  locationFilterListAPI,
  SET_DATA_GUARD_LOCATION_FILTERS,
  SET_DATA_GUARD_OWNERS_FILTERS,
  SET_DATA_GUARD_POLICY_SUBTYPE_FILTERS,
  SET_DATA_GUARD_SEVERITY_FILTERS,
  SET_DATA_GUARD_USER_ROLES_FILTERS,
  SET_NOTIFICATION_UPDATE_STATUS,
  SET_REVOKE_ACCESS_UPDATE_STATUS,
  SeverityFilterMap,
} from "../../Utility/DataguardConstant";
import { getAxiosHeaders, getService } from "../../../../library/RestAPI";
import { maskUsername } from "../../../SysGuard/SysGuardCommonComp";

export function* getDataGuardFiltersList(action) {
  try {
    const fromTimeStamp = yield select(
      (state) => state.DataguardReducer.fromTimeStamp
    );
    const toTimeStamp = yield select(
      (state) => state.DataguardReducer.toTimeStamp
    );

    const { filterEndpoint, filterType } = action.payload;

    const options = {
      method: "GET",
      url:
        filterType === "locations"
          ? locationFilterListAPI(fromTimeStamp, toTimeStamp)
          : `${getDetailsURL(filterEndpoint)}`,
      headers: getAxiosHeaders(true),
    };

    const response = yield getService(options);

    if (response && response.status === 200) {
      if (filterType === "locations") {
        yield put({
          type: SET_DATA_GUARD_LOCATION_FILTERS,
          payload: response.data || [],
        });
      }

      if (filterType === "behaviormodels") {
        yield put({
          type: SET_DATA_GUARD_POLICY_SUBTYPE_FILTERS,
          payload: response.data || [],
        });
        yield put({
          type: SET_DATA_GUARD_SEVERITY_FILTERS,
          payload: ["HIGH", "MEDIUM", "LOW"],
        });
      }

      if (filterType === "roles") {
        yield put({
          type: SET_DATA_GUARD_USER_ROLES_FILTERS,
          payload: response.data || [],
        });
      }

      if (filterType === "publicdata") {
        yield put({
          type: SET_DATA_GUARD_OWNERS_FILTERS,
          payload: response.data || [],
        });
      }
    } else {
      console.error("Error fetching filter data");
    }
  } catch (error) {
    console.error("Error fetching filter data:", error);
  }
}

function* fetchDetailPageDataSaga(action) {
  try {
    const {
      pageType,
      apiEndpoint,
      fromTimeStamp,
      toTimeStamp,
      page,
      rowsPerPage,
      locationFilters = [],
      policySubtypeFilters = [],
      severityFilters = [],
      userRolesFilters = [],
      ownersFilters = [],
      filterType,
    } = action.payload;

    const notificationStatus = yield select(
      (state) => state.DataguardReducer.notificationUpdateStatus
    );
    const revokeAccessUpdateStatus = yield select(
      (state) => state.DataguardReducer.revokeAccessUpdateStatus
    );

    const joinFilters = (filters) =>
      Array.isArray(filters) && filters.length > 0 ? filters.join(",") : "";

    const paramData = {};


    if (filterType === "locations" && locationFilters.length > 0) {
      paramData.countries = joinFilters(locationFilters);
    }

    if (filterType === "behaviormodels") {
      if (policySubtypeFilters.length > 0) {
        paramData.policies = joinFilters(policySubtypeFilters);
      }
      if (severityFilters.length > 0) {
        paramData.severities = severityFilters
          .map((s) => s.toLowerCase())
          .join(",");
      }
    }

    if (filterType === "roles" && userRolesFilters.length > 0) {
      paramData.roleNames = joinFilters(userRolesFilters);
    }

    if (filterType === "publicdata" && ownersFilters.length > 0) {
      paramData.owners = joinFilters(ownersFilters);
    }

    yield put({ type: "FETCH_DETAIL_PAGE_DATA_START" });

    const url = `${getDetailsURL(
      apiEndpoint
    )}?fromTimeStamp=${fromTimeStamp}&toTimeStamp=${toTimeStamp}&size=${rowsPerPage}&page=${page}`;

    const response = yield getService({
      method: "GET",
      url,
      headers: getAxiosHeaders(true),
      params: paramData,
    });


    if (response?.status === 200) {
      yield put({
        type: "FETCH_DETAIL_PAGE_DATA_SUCCESS",
        payload: { pageType, data: response.data || [] },
      });

      if (notificationStatus)
        yield put({ type: SET_NOTIFICATION_UPDATE_STATUS, payload: false });

      if (revokeAccessUpdateStatus)
        yield put({ type: SET_REVOKE_ACCESS_UPDATE_STATUS, payload: false });
    } else {
      yield put({
        type: "FETCH_DETAIL_PAGE_DATA_FAILURE",
        payload: "API call failed",
      });
    }
  } catch (error) {
    yield put({
      type: "FETCH_DETAIL_PAGE_DATA_FAILURE",
      payload: error.message,
    });
  }
}

export default function* DetailPageSaga() {
  yield takeEvery("FETCH_DETAIL_PAGE_DATA_REQUEST", fetchDetailPageDataSaga);
  yield takeEvery(GET_DATA_GUARD_FILTERS_LIST, getDataGuardFiltersList);
}